/* eslint-disable no-console */
const _ = require('lodash');
const { EventEmitter } = require('events');
let monitoring;
try {
  monitoring = require('hive-monitoring-client');
} catch (e) {
//  console.warn('Unable to load hive-monitoring-client. This feature will be disabled.');
}

// NOTE: commenting out everything related to request caching
// since it's not currently useful, but it might be pretty soon
// const cache = require('./cache');
// const log = require('hive-logger');

function Client({ request = require('superagent'), baseUrl = '', enableMonitoring = false }) {
  const client = new EventEmitter();

  function stripGuid(s) {
    return s.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi, 'guid');
  }

  async function send(method, relUrl, extras) {
    let label = `${baseUrl}|${stripGuid(relUrl)}[${method}]`;
    let b = (monitoring && enableMonitoring) ? monitoring.start('restclient', label) : { stop: () => { } };

    let r = request;
    let url = `${baseUrl}${relUrl}`;
    const params = { method, url, json: true };
    _.assignIn(params, extras);

    // Configure the request to use the HTTP method
    r = r[_.toLower(method)](url);
    // returns JSON
    r = r.set('Accept', 'application/json');

    // Set the headers passed as when using request
    let headers = _.get(extras, 'headers');
    _.each(headers, (v, k) => {
      r = r.set(k, v);
    });

    client.emit('headers', (k, v) => {
      r = r.set(k, v);
    });

    let jsonData = _.get(extras, 'json');
    if (jsonData) {
      r = r.send(jsonData);
    } else {
      let formData = _.get(extras, 'form');
      if (formData) {
        r = r.type('form');
        _.each(formData, (v, k) => {
          r = r.send(`${k}=${v}`);
        });
      }
    }

    let res;
    try {
      res = await r;
      res = { content: res.body, status: res.statusCode };
      b.stop(false);
      return res;
    } catch (e) {
      b.stop(false);
      // the http-rest-client will throw with the {status, content} object
      // on 3xx, 4xx, 5xx
      let response = _.get(e, 'response');
      if (response) {
        return { content: e.response.body, status: e.response.statusCode };
      }
      throw e;
    }
  }

  function del(relUrl, extras = {}, data) {
    if (data) {
      extras = _.assignIn({ json: data }, extras);
    }
    return send('DELETE', relUrl, extras);
  }

  function get(relUrl, extras = {}) {
    return send('GET', relUrl, extras);
  }

  function post(relUrl, data, extras = {}) {
    return send('POST', relUrl, _.assignIn({ json: data }, extras));
  }

  function postRaw(relUrl, options = {}) {
    return send('POST', relUrl, options);
  }

  function put(relUrl, data, extras = {}) {
    return send('PUT', relUrl, _.assignIn({ json: data }, extras));
  }

  function putRaw(relUrl, options = {}) {
    return send('PUT', relUrl, options);
  }

  function patch(relUrl, data, extras = {}) {
    return send('PATCH', relUrl, _.assignIn({ json: data }, extras));
  }

  function patchRaw(relUrl, options = {}) {
    return send('PATCH', relUrl, options);
  }

  return _.assignIn(client, { del, get, post, postRaw, put, putRaw, patch, patchRaw });
}

module.exports = Client;
